import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=33f1778e&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33f1778e')) {
      api.createRecord('33f1778e', component.options)
    } else {
      api.reload('33f1778e', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=33f1778e&", function () {
      api.rerender('33f1778e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22IB2mcVOfTtg/JS/comp/ImgFallback.vue"
export default component.exports